<template>
    <div :class="cssClass">
        <div class="no-results-text" v-html="$te(message) ? $t(message, translationPlaceholders) : $t('common.no_results_1')"></div>
    </div>
</template>

<script>
export default {
    name: "NoResultsSection",
    props: {
        message: {
            type: String,
            required: false
        },
        cssClass: {
            type: String,
            default: 'no-results-section-type-1'
        },
        translationPlaceholders: {
            type: Object,
            default: () => ({})
        },
    }
}
</script>